export default __webpack_public_path__ + "../staticImages/logo-claim-paypal.jpg";